// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-setting[data-v-569833b9] {\n  margin-bottom: 18px;\n}", ""]);
// Exports
module.exports = exports;
